<script setup>
import { useCotizacionEstandarStore } from "@/store/cotizaciones/estandar";
import { storeToRefs } from "pinia";
import useCotizacionEstandarSourcesStore from "@/store/cotizaciones/estandar/sources";
const { sources, total, totalSources } = storeToRefs(useCotizacionEstandarSourcesStore());
const { stateCalculosLeaseParameters } = storeToRefs(
  useCotizacionEstandarStore()
);
</script>

<template>
  <section>
    <div class="table-response">
      <table class="table table-sm text-xs table-bordered">
        <thead>
          <tr>
            <th>Equipment</th>
            <th>Facility Draw</th>
            <th>Lessee Contri</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Equipment</td>
            <td>${{ sources.equipment.equipment.facilityDraw }}</td>
            <td>${{ sources.equipment.equipment.lesseeContri }}</td>
            <td>${{ sources.equipment.equipment.total }}</td>
          </tr>
          <tr>
            <td>VAT on Equipment</td>
            <td>${{ sources.equipment.equipmentVAT.facilityDraw }}</td>
            <td>${{ sources.equipment.equipmentVAT.lesseeContri }}</td>
            <td>${{ sources.equipment.equipmentVAT.total }}</td>
          </tr>
          <tr>
            <td>Servicer Contribution</td>
            <td>${{ sources.equipment.servicerContribution.facilityDraw }}</td>
            <td>${{ sources.equipment.servicerContribution.lesseeContri }}</td>
            <td>${{ sources.equipment.servicerContribution.total }}</td>
          </tr>
        </tbody>
        <tbody
          style="border-top: 1.6px #000 solid !important"
          class="text-center"
        >
          <tr>
            <th>Total Paid to OEM (New) / Lessee (SLB)</th>
            <th>${{ total.equipment.facilityDraw }}</th>
            <th>${{ total.equipment.lesseeContri }}</th>
            <th>${{ total.equipment.total }}</th>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th colspan="4">Servicer Fees</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Opening Fee</td>
            <td>
              <input v-model="stateCalculosLeaseParameters.opFeeFacility" />
            </td>
            <td>${{ sources.servicerFees.openingFee.lesseeContri }}</td>
            <td>${{ sources.servicerFees.openingFee.total }}</td>
          </tr>
          <tr>
            <td>VAT on Opening Fee</td>
            <td>
              <input v-model="stateCalculosLeaseParameters.vatOpFeeFacility" />
            </td>
            <td>${{ sources.servicerFees.vatOpeningFee.lesseeContri }}</td>
            <td>${{ sources.servicerFees.vatOpeningFee.total }}</td>
          </tr>
        </tbody>
        <tbody
          style="border-top: 1.6px #000 solid !important"
          class="text-center"
        >
          <tr>
            <th>Servicer Cash Flow</th>
            <th>${{ total.equipmentVAT.facilityDraw }}</th>
            <th>${{ total.equipmentVAT.lesseeContri }}</th>
            <th>${{ total.equipmentVAT.total }}</th>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th colspan="4">1st Month's Rent</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Opening Fee</td>
            <td>
              <input v-model="stateCalculosLeaseParameters.firstMonthsRent" />
            </td>
            <td>${{ sources.firstMonthsRent.firstMonthsRent.lesseeContri }}</td>
            <td>${{ sources.firstMonthsRent.firstMonthsRent.total }}</td>
          </tr>
          <tr>
            <td>VAT on Opening Fee</td>
            <td>
              <input v-model="stateCalculosLeaseParameters.firstMonthVATOpFee" />
            </td>
            <td>${{ sources.firstMonthsRent.vatOnOpeningFee.lesseeContri }}</td>
            <td>${{ sources.firstMonthsRent.vatOnOpeningFee.total }}</td>
          </tr>
        </tbody>
        <tbody
          style="border-top: 1.6px #000 solid !important"
          class="text-center"
        >
          <tr>
            <th>Servicer Cash Flow</th>
            <th>${{ total.firstMonthsRent.facilityDraw }}</th>
            <th>${{ total.firstMonthsRent.lesseeContri }}</th>
            <th>${{ total.firstMonthsRent.total }}</th>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th colspan="4">Partial Day Interest</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Partial Day Rent</td>
            <td>
              <input v-model="stateCalculosLeaseParameters.partialDayRent" />
            </td>
            <td>${{ sources.partialDayInterest.partialDayRent.lesseeContri }}</td>
            <td>${{ sources.partialDayInterest.partialDayRent.total }}</td>
          </tr>
          <tr>
            <td>Partial Day VAT</td>
            <td>
              <input v-model="stateCalculosLeaseParameters.partialDayVAT" />
            </td>
            <td>${{ sources.partialDayInterest.partialDayVAT.lesseeContri }}</td>
            <td>${{ sources.partialDayInterest.partialDayVAT.total }}</td>
          </tr>
        </tbody>
        <tbody
          style="border-top: 1.6px #000 solid !important"
          class="text-center"
        >
          <tr>
            <th>Partial Day Interest Total</th>
            <th>${{ total.partialDayInterest.facilityDraw }}</th>
            <th>${{ total.partialDayInterest.lesseeContri }}</th>
            <th>${{ total.partialDayInterest.total }}</th>
          </tr>
          <tr>
            <td colspan="4" class="py-3"></td>
          </tr>
        </tbody>
        <tbody
          style="border-top: 1.6px #000 solid !important"
          class="text-center"
        >
          <tr style="font-size: 15px; color: #000;">
            <th>Total</th>
            <th>${{ totalSources.facilityDraw }}</th>
            <th>${{ totalSources.lesseeContri }}</th>
            <th>${{ totalSources.total }}</th>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
